import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { LoadingState } from '@/components/primitives'
import { type PlanId } from '@/lib/pricing'
import { resolveRouteLocale } from '@/lib/route-locale'

interface ProtectedRouteProps {
  children: ReactNode
  requiredPlans?: PlanId[]
}

export function ProtectedRoute({ children, requiredPlans }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, plan } = useAuth()
  const location = useLocation()
  const [, urlLocale] = location.pathname.match(/^\/([a-zA-Z]{2})(?:\/|$)/) || []
  const locale = resolveRouteLocale([urlLocale])

  if (isLoading) {
    return (
      <div className="min-h-screen bg-[var(--pd-bg)] flex items-center justify-center">
        <LoadingState type="page" />
      </div>
    )
  }

  if (!isAuthenticated) {
    // Redireciona para o login localizado, preservando a rota original
    return <Navigate to={`/${locale}/login`} state={{ from: location }} replace />
  }

  if (requiredPlans && !requiredPlans.includes(plan)) {
    return <Navigate to={`/${locale}/pricing`} replace />
  }

  return <>{children}</>
}
